import React from "react";
import { Parallax } from "react-parallax";

function Counter() {
  return (
    <section id="counter" className=" hero-wrap">
      <div className="hero-mask opacity-8 bg-dark" />

      <Parallax
        bgImage="images/intro-bg-4.jpg"
        bgImageAlt="Intro"
        strength={200}
      >
        <div className="hero-content section">
          <div className="container">
            <div className="row gy-5">
              <div className="col-6 col-md-3">
                <div className="featured-box text-center">
                  <div className="featured-box-icon text-white">
                    <i className="fas fa-users" />
                  </div>
                  <h4 className="text-11 text-white fw-500">+ 1500</h4>
                  <p className="text-light mb-0 fs-4">Parceiros</p>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="featured-box text-center">
                  <div className="featured-box-icon text-white">
                    <i className="fas fa-star-half-alt" />
                  </div>
                  <h4 className="text-11 text-white fw-500">+ 150 mil</h4>
                  <p className="text-light mb-0 fs-4 ">Alunos</p>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="featured-box text-center">
                  <div className="featured-box-icon text-white">
                    <i className="fas fa-download" />
                  </div>
                  <h4 className="text-11 text-white fw-500">+ 20</h4>
                  <p className="text-light mb-0 fs-4">Cursos Oferecidos</p>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="featured-box text-center">
                  <div className="featured-box-icon text-white">
                    <i className="fas fa-gem" />
                  </div>
                  <h4 className="text-11 text-white fw-500">26</h4>
                  <p className="text-light mb-0 fs-4">Estados Presentes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Parallax>
    </section>
  );
}

export default Counter;
